import axios from 'axios';

import { FLEX_DUTY_LINE } from 'RestAPIs/endpoints';

export const deleteFlexDutyLine = (
  processInstanceId: string,
  disconnectReason: string | undefined,
  dht: number | undefined,
  returnToFlex: boolean
) => {
  const payload = {
    processInstanceId,
    disconnectReason,
    dht: dht !== undefined ? dht : '',
    returnToFlex
  };

  const queryParams = new URLSearchParams(payload as any).toString();

  return axios.delete(`${FLEX_DUTY_LINE}?${queryParams}`);
};
